module.exports = __webpack_public_path__ + "img/nl.6a38ab09.png";